import { render } from "./InstituteSvg.vue?vue&type=template&id=c9660432"
const script = {}
script.render = render

export default script